import { FactoryStaticOpts } from 'imask';
import React from 'react';
import { IMaskInput } from 'react-imask';
import { InputBaseComponentProps } from '@mui/material';

type TextMaskProps = Omit<InputBaseComponentProps, 'onChange'> &
    FactoryStaticOpts & {
        onChange: (event: { target: { name: string; value: string } }) => void;
        name: string;
    };

export const MaskedTextField = React.forwardRef<
    HTMLInputElement,
    TextMaskProps
>(function MaskTextField(props, ref) {
    const { onChange, inputProps, ...other } = props;
    return (
        <IMaskInput
            {...other}
            inputRef={ref}
            onAccept={value => {
                if (onChange) {
                    onChange({
                        target: {
                            name: props['name'],
                            value,
                        },
                    });
                }
            }}
            // overwrite
        />
    );
});
